import styled from 'styled-components'

const makeBackgroundPosition = (background, yOffset = 0) => {
  return `${background.x}px ${background.y + yOffset}px`
}

export default styled.span`
  background-image: url(${props => props.theme.horoscopes.background});
  background-position: ${props => makeBackgroundPosition(props.backgroundPosition)};
  background-repeat: no-repeat;
  content: '';
  height: 56px;
  opacity: 0.2;
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
`
